export function requestIdleCallback(callback: () => any, timeout: number) {
  let didInvoke: boolean = false;
  const doIt = () => {
    if (!didInvoke) {
      didInvoke = true;
      callback();
    }
  };
  if (window.requestIdleCallback) {
    window.requestIdleCallback(doIt, {timeout});
  }
  setTimeout(doIt, timeout);

}

export async function waitForIdleOrTimeout(timeout: number) {
  return new Promise((resolve) => requestIdleCallback(resolve, timeout));
}
